export default __webpack_public_path__ + "static/media/artist4.80706431.png";